import { render, staticRenderFns } from "./admin-pending-ussd-payments.vue?vue&type=template&id=82b488e2&"
import script from "./admin-pending-ussd-payments.vue?vue&type=script&lang=js&"
export * from "./admin-pending-ussd-payments.vue?vue&type=script&lang=js&"
import style0 from "./admin-pending-ussd-payments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports